<template>
  <div class="modal fade" id="analogsModal" style="overflow: auto!important;" tabindex="-1" role="dialog"
    aria-labelledby="analogsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-v2 modal-lg" role="document">
      <div class="modal-content modal-content-v2">
        <div class="modal-header modal-header-v2">
          <div class="header-content-v2">
            <i class="fa fa-copy header-icon-v2"></i>
            <h5 class="modal-title-v2" id="analogsModalLabel">Аналоги</h5>
          </div>
          <button type="button" class="close close-v2" data-dismiss="modal" aria-label="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body-v2">
          <!-- Material Info -->
          <div v-if="material" class="material-info-v2 material-info-grid">
            <div class="material-image-v2">
              <img :src="appconfig.Point + `/` + material.image" :alt="material.full_name" />
            </div>
            <div class="material-details-v2">
              <h6 class="material-title-v2">{{ material.full_name }}</h6>
              <div class="material-meta-v2">
                <span class="material-code-v2">Код: {{ material.code }}</span>
                <span class="material-status-v2" :class="material.quantity == 0 ? 'status-order' : 'status-stock'">
                  <i :class="material.quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                  {{ material.quantity == 0 ? 'Термін постачання до: ' + material.terms : 'В наявності' }}
                </span>
              </div>
            </div>
            <div v-if="material.price > 0" class="material-price-v2">
              <span class="price-value-v2">{{ (+material.p).toFixed(2) }}</span>
              <span class="price-currency-v2">{{ material.cy_name }}
                / {{ what === 'materials' ? material.base_unit_name : material.sale_unit_name }}
              </span>
            </div>
          </div>

          <!-- Loading -->
          <div v-if="loading" class="loading-container-v2">
            <div class="preloader-v2">
              <div class="spinner-v2"></div>
              <p class="loading-text-v2">Завантаження...</p>
            </div>
          </div>

          <!-- Analogs List -->
          <div v-if="analogs.length && !loading" class="results-list-v2">
            <div v-for="(item, index) in analogs" :key="index" class="result-item-v2">
              <div class="result-image-v2">
                <img :src="appconfig.Point + `/` + item.image" :alt="item.full_name" loading="lazy" />
              </div>

              <div class="result-content-v2">
                <div class="result-header-v2">
                  <div v-if="item.on_order" class="order-badge-v2">Під замовлення</div>
                  <h4 class="result-title-v2">{{ item.full_name }}</h4>
                  <div class="result-meta-v2">
                    <span class="result-code-v2">Код: {{ item.code }}</span>
                    <span class="result-status-v2" :class="item.quantity == 0 ? 'status-order' : 'status-stock'">
                      <i :class="item.quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                      {{ item.quantity == 0 ? 'Термін постачання до: ' + item.terms : 'В наявності' }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="result-price-v2">
                <div v-if="item.price > 0" class="price-info-v2">
                  <span class="price-value-v2">{{ (+item.p).toFixed(2) }}</span>
                  <span class="price-currency-v2">{{ item.cy_name }}

                    / {{ what == 'materials' ? item.base_unit_name : item.sale_unit_name }}
                  </span>
                </div>
              </div>

              <div class="result-select-v2">
                <div v-if="canSelect(item)" class="select-actions-v2">
                  <button class="btn-v2 btn-primary-v2" :id="'_' + item.ref" @click="takeItem(item)"
                    :disabled="exists(item.ref)">
                    <i class="fa fa-check"></i>
                    Обрати
                  </button>
                  <button v-if="item.recommends != undefined && item.recommends.length > 0 && what === 'materials'"
                    class="btn-v2 btn-outline-v2 btn-sm-v2" :id="'_' + item.ref" @click.prevent="takeItemEdges(item)">
                    <i class="fa fa-border-all"></i>
                    Кромки
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from 'jquery';

export default {
  name: "recommendRender",
  props: ['what', 'responseData', 'materials', 'edges'],
  data() {
    return {
      appconfig: appconfig,
      analogs: [],
      material: false,
      received: [],
      loading: false,
    }
  },
  computed: {
    details() {
      return this.$store.state.data.details;
    },
    allowNoPrice() {
      return this.$store.state.auth.settings.allow_no_price || false;
    },
  },
  methods: {
    exists(ref) {
      return this.materials.find(el => el.ref === ref) || this.edges.find(el => el.ref === ref) ? 'disabled' : false
    },
    canSelect(item) {
      // Если allow_no_price включен, показываем всегда
      if (this.allowNoPrice) {
        return true;
      }
      // Иначе показываем только если есть цена
      return item.price > 0;
    },
    takeItem(item) {
      let elem = this[this.what].find(el => el.ref === item.ref);
      if (elem) return;

      let replace = this.$store.state.data.replace;
      // Замендобавление
      if (replace != null) {
        let toReplaceIndex = this[this.what].findIndex(el => el.ref === replace);
        if (toReplaceIndex !== -1 && confirm('Замінити ' + this[this.what][toReplaceIndex].full_name + ' на ' + item.full_name)) {
          let current = this[this.what][toReplaceIndex];
          this.replaceInDetails(item); //change in details
          item = { ...item, color_show: false, color: current.color };
          this.$root.$emit('on-replace-product', this.what, item, replace);
          this.$store.commit('data/SET_REPLACE', null);
          document.getElementById('_' + item.ref).setAttribute("disabled", "disabled");
          $('#analogsModal').modal('hide');
        }
      } else {
        this.$root.$emit('on-save-product', this.what, item);
        document.getElementById('_' + item.ref).setAttribute("disabled", "disabled");
      }
    },
    replaceInDetails(item) {
      let replace = this.$store.state.data.replace;

      if (this.what === 'materials') {
        this.details
          .filter(el => el.material === replace)
          .forEach(i => {
            i.material = item.ref;
          });
      } else if (this.what === 'edges') {
        this.details
          .filter(el => el.edge_t === replace)
          .forEach(i => {
            i.edge_t = item.ref;
          });
        this.details
          .filter(el => el.edge_b === replace)
          .forEach(i => {
            i.edge_b = item.ref;
          });
        this.details
          .filter(el => el.edge_l === replace)
          .forEach(i => {
            i.edge_l = item.ref;
          });
        this.details
          .filter(el => el.edge_r === replace)
          .forEach(i => {
            i.edge_r = item.ref;
          });
        this.details
          .filter(el => el.edge_template === replace)
          .forEach(i => {
            i.edge_template = item.ref;
          });
      }
    },
    takeItemEdges(item) {
      this.$root.$emit('edges_change', { 'edges': item.recommends || [], 'material': item, what: this.what });
      this.$store.commit('data/SET_MODAL', 'analogsModal');
      $('#analogsModal').modal('hide');
      $('#recommendModal').modal();
    },
    takeItemAnalogs(item) {
      this.$root.$emit('analogs_change', { 'analogs': item.analogs || [], 'material': item, what: this.what });
    },
    receive() {
      let request = '';
      this.analogs.forEach((el, i) => {
        request += 'i' + el.code;
      });
      this.loading = true;
      axios.post(appconfig.Point + 'api/constructor/v1/products', {
        by: 'code',
        search: request,
        take: 20,
        token: (this.$store.state.auth.user.token || null)
      })
        .then(response => {
          this.analogs = response.data;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.$root.$off('analogs_change');
    this.$root.$off('update');

    this.$root.$on('analogs_change', data => {
      this.analogs = data.analogs;
      this.material = data.material;
      this.what = data.what;
      this.receive();
    });
    this.$root.$on('update', i => {
      this.$forceUpdate();
    });

    $('#analogsModal').on('hidden.bs.modal', () => {
      if (this.$store.state.data.modal !== 'analogsModal') {
        this.$root.$emit('modal.change')
      }
    });
  }
}
</script>

<style scoped>
/* Component-specific overrides for analogsRender */
.material-info-grid {
  display: grid;
  grid-template-columns: 64px 1fr auto;
  gap: 16px;
  align-items: center;
}
</style>
